import { observer } from 'mobx-react';
import React from 'react';
import { Button, Grid, GridColumn, Heading, List, ListItem, Modal, ModalCloser, ModalContent, ModalFooter, Text } from '@teliaee/design-system';
import useStores from '../stores/UseStores';
import { useIsTabletHook } from '../util/hooks/useIsMobile';
import PasskeyOfferRegisterResultModal from './PasskeyOfferRegisterResultModal';

const PasskeyOfferRegister = observer((): React.JSX.Element => {
  const {
    passkeyStore: {
      offerRegisterModalVisible,
      offerRegisterModalOnComplete,
      register,
      skipPasskeyOfferRegister,
      wasPasskeyRegisterSuccessful,
      isWebAuthnInProgress,
    },
    translateStore: { translate },
  } = useStores();
  const { isTablet } = useIsTabletHook();

  const skipPasskeyRegister = async () => {
    await skipPasskeyOfferRegister();
    offerRegisterModalOnComplete();
  };

  const addPasskey = () => register();

  if (wasPasskeyRegisterSuccessful !== null) {
    return <PasskeyOfferRegisterResultModal />;
  }

  return (
    <Modal isOpen={offerRegisterModalVisible} isFullHeight={!isTablet} onClose={skipPasskeyRegister}>
      <ModalContent>
        <Text>
          <Grid>
            <GridColumn width={['xs-11']}>
              <Heading level={1} className="h3">
                {translate('passkey.offerRegister.heading')}
              </Heading>
            </GridColumn>
          </Grid>
          <p>{translate('passkey.offerRegister.subHeading')}</p>
          <List type="icon">
            <ListItem icon="#fingerprint">{translate('passkey.offerRegister.listItem.fingerprint')}</ListItem>
            <ListItem icon="#face-id">{translate('passkey.offerRegister.listItem.faceId')}</ListItem>
            <ListItem icon="#phone-lock">{translate('passkey.offerRegister.listItem.phoneLock')}</ListItem>
          </List>
          <Button link text={translate('panel.passkey.cta')} target="_blank" url={translate('panel.passkey.cta.url')} />
        </Text>
      </ModalContent>
      <ModalFooter>
        <Grid align={isTablet ? ['between-xs'] : ['around-xs']}>
          <ModalCloser>
            <Button text={translate('passkey.offerRegister.footer.skip')} link onClick={skipPasskeyRegister} />
          </ModalCloser>
          <ModalCloser>
            <Button disabled={isWebAuthnInProgress} text={translate('passkey.offerRegister.footer.addPasskey')} type="expressive" onClick={addPasskey} />
          </ModalCloser>
        </Grid>
      </ModalFooter>
    </Modal>
  );
});

export default PasskeyOfferRegister;
